import script from "./BlogForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogForm.vue?vue&type=script&setup=true&lang=js"

import "./BlogForm.vue?vue&type=style&index=0&id=c6cdfe64&scoped=true&lang=css"

import exportComponent from "C:\\wisata-jepara-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6cdfe64"]])

export default __exports__